import { api } from "@api/api";
import { Level } from "@modules/levels/types";
import { LevelFormValues } from "@modules/levels/validations";

export async function createLevelService(data: LevelFormValues): Promise<Level> {
  const { data: level } = await api.post<Level>("v1/level_admin/", data);

  return level;
}
